import React, {useState, useEffect, useRef} from "react";
import {CourierSummary} from "./courierSummary/CourierSummary";
import {Tabs} from "antd";

import {CourierDocuments} from "./courierDocuments/CourierDocuments";
import {CourierCallRecords} from "./courierCallRecords/CourierCallRecords";

import {TabsContainer} from "../courierDetailStyles";

import {useStore} from "hooks/useStore";
import CourierAllDocumentsDownload from "./courierDocuments/CourierAllDocumentsDownload";
import {CourierNotificationsTab} from "../courierNotificationsTab/CourierNotificationsTab";

export const CourierOnboardingTab = ({courier, courierLoading = true, reloadCourier}) => {
    const stores = useStore();
    const [tabKey, setTabKey] = useState();
    const tabContainerRef = useRef(null);

    // Tab değiştiğinde otomatik scroll
    useEffect(() => {
        if (tabContainerRef.current && tabKey) {
            tabContainerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [tabKey]);

    /* if (courierLoading || !courier) {
        return <div>Yükleniyor...</div>;
    } */
    const hasAnyDocument = () => {
        return Object.values(courier?.documents || {})?.some(doc => doc?.file?.length > 0);
    };

    return (
        <div ref={tabContainerRef}>
            <TabsContainer
                data-testid="curierDetailScreen"
                activeKey={tabKey}
                defaultActiveKey="courier-summary"
                onChange={key => {
                    setTabKey(key);
                }}
                tabBarExtraContent={
                    <>
                        {stores.meStore.checkRole("downloadCourierDocuments") &&
                        stores.meStore.checkPermission("couriers.documentActions") ? (
                            <CourierAllDocumentsDownload
                                courierId={courier._id}
                                hasAnyDocument={hasAnyDocument()}
                            />
                        ) : null}
                    </>
                }
            >
                <Tabs.TabPane
                    tab={<span data-testid="courier-summary">Kurye Bilgileri</span>}
                    key="courier-summary"
                >
                    <CourierSummary
                        courier={courier}
                        loading={courierLoading}
                        reloadCourier={reloadCourier}
                    />
                </Tabs.TabPane>
                {stores.meStore.checkRole("listCourierOnboarding") && (
                    <Tabs.TabPane
                        tab={<span data-testid="courier-documents">Kurye Belgeleri</span>}
                        key="courier-documents"
                    >
                        <CourierDocuments
                            courier={courier}
                            reloadCourier={reloadCourier}
                            loading={courierLoading}
                        />
                    </Tabs.TabPane>
                )}
                {/*  <Tabs.TabPane
                    tab={
                        <span data-testid="courier-equipment-requests">
                            Kurye Ekipman Talepleri
                        </span>
                    }
                    key="courier-equipment-requests"
                >
                    <CourierEquipmentRequests
                        courier={courier}
                        reloadCourier={reloadCourier}
                        loading={courierLoading}
                    />
                </Tabs.TabPane> */}
                {stores.meStore.checkRole("updateCourierCallRecords") &&
                    stores.meStore.checkPermission("couriers.callRecords") && (
                        <Tabs.TabPane
                            tab={
                                <span data-testid="courier-call-records">
                                    Kurye Arama Kayıtları
                                </span>
                            }
                            key="courier-call-records"
                        >
                            <CourierCallRecords
                                courier={courier}
                                reloadCourier={reloadCourier}
                                loading={courierLoading}
                            />
                        </Tabs.TabPane>
                    )}
                {(stores.meStore.checkRole("isAdmin") || stores.meStore.role === "software") && (
                    <Tabs.TabPane
                        tab={<span data-testid="courier-notifications">Kurye Bildirimleri</span>}
                        key="courier-notifications"
                    >
                        <CourierNotificationsTab courierId={courier?._id} />
                    </Tabs.TabPane>
                )}
            </TabsContainer>
        </div>
    );
};
